function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m0.44624 20.09c0-10.778 8.7498-19.527 19.527-19.527 10.815 0 19.527 8.7498 19.527 19.527 0 10.815-8.7123 19.527-19.527 19.527-10.778 0-19.527-8.7123-19.527-19.527",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(.59302 0 0 .58896 3.7903 7.1705)",
  strokeMiterlimit: 10,
  strokeWidth: 1.6921
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m7.4683 7.8197c0-1.9989 1.6314-3.6194 3.6446-3.6194h17.008c2.0132 0 3.6446 1.6204 3.6446 3.6194v14.477c0 1.9989-1.6314 3.6194-3.6446 3.6194h-17.008c-2.0132 0-3.6446-1.6204-3.6446-3.6194z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m11.165 4.1414h17.022c2.0097 0 3.6377 1.5815 3.6377 3.5328v4.0506h-24.297v-4.0506c0-1.9514 1.6279-3.5328 3.6377-3.5328z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m11.106 4.2003h17.022c2.0097 0 3.6377 1.6122 3.6377 3.6015v4.1293h-24.297v-4.1293c0-1.9893 1.6279-3.6015 3.6377-3.6015z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(1.1523,0,0,1.1559,-6.7194,-2.0252)",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m22.271 25.663c0-1.586 1.4228-2.8721 3.1811-2.8721s3.1811 1.2861 3.1811 2.8721-1.4228 2.8721-3.1811 2.8721-3.1811-1.2861-3.1811-2.8721z",
  fill: "#fff",
  strokeWidth: 1.446
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m25.535 23.468c-1.1567 0-2.0937 0.89609-2.0937 2.0007 0 1.1052 0.93697 2.0007 2.0937 2.0007 1.1568 0 2.0937-0.89552 2.0937-2.0007 0-1.1046-0.93697-2.0007-2.0937-2.0007zm-0.88491-4.8923h1.8103l0.52054 1.6095 1.5558 0.53708 1.5096-0.66058 1.2493 1.1971-0.77502 1.3619 0.60151 1.5274 1.6426 0.53651v1.6509l-1.5963 0.53651-0.64778 1.4033 0.86178 1.5274-1.3823 1.1971-1.5096-0.7433-1.5096 0.61922-0.56102 1.486h-1.8103l-0.56102-1.5274-1.3823-0.53651-1.5963 0.66058-1.2088-1.1557 0.64778-1.5687-0.52054-1.3206-1.6831-0.57786v-1.6095l1.5963-0.57786 0.60729-1.4447-0.78081-1.5274 1.2551-1.1971 1.5963 0.70194 1.5096-0.57786z",
  fill: "#adb9ca",
  strokeWidth: 0.57766
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m25.675 23.468c-1.1568 0-2.0937 0.89609-2.0937 2.0007 0 1.1052 0.93697 2.0007 2.0937 2.0007s2.0937-0.89552 2.0937-2.0007c0-1.1046-0.93697-2.0007-2.0937-2.0007zm-0.88491-4.8923h1.8103l0.52054 1.6095 1.5558 0.53708 1.5096-0.66058 1.2493 1.1971-0.77502 1.3619 0.60151 1.5274 1.6426 0.53651v1.6509l-1.5963 0.53651-0.64778 1.4033 0.86178 1.5274-1.3823 1.1971-1.5096-0.7433-1.5096 0.61922-0.56102 1.486h-1.8103l-0.56102-1.5274-1.3823-0.53651-1.5963 0.66058-1.2088-1.1557 0.64778-1.5687-0.52054-1.3206-1.6831-0.57786v-1.6095l1.5963-0.57786 0.60729-1.4447-0.7808-1.5274 1.2551-1.1971 1.5963 0.70194 1.5096-0.57786z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.86648
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(.7261 0 0 .72837 9.679 -.14558)"
}, React.createElement("path", {
  className: "icon-primary",
  d: "m18.417 41.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  opacity: 0.99,
  strokeWidth: 1.4542
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m18.417 41.178h6.2926v3.3402l11.913-6.6806-11.913-6.6806v3.3402h-6.2926z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8,
  strokeWidth: 1.3751
}), React.createElement("circle", {
  className: "icon-tertiary",
  cx: 18.16,
  cy: 37.876,
  r: 3.2945,
  fill: "#fff",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8,
  strokeWidth: 1.3751
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(24.094 26.465 15.539)",
  fillRule: "evenodd"
}, React.createElement("path", {
  className: "icon-primary",
  d: "m26.853 14.441-2.5658 0.73603 5.2081 4.2644 2.1584-6.4611-2.7186 0.78093c-2.9351-5.364-9.4038-5.0529-12.441-1.6371-1.076 1.4657 0.80859 2.4161 1.6108 1.3772 1.7063-2.0247 6.405-2.9922 8.748 0.93964z",
  fill: "#ecaec6",
  strokeWidth: 0.66667
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m26.853 14.441-2.5658 0.73603 5.2081 4.2644 2.1584-6.4611-2.7186 0.78093c-2.9351-5.364-9.4038-5.0529-12.441-1.6371-1.076 1.4657 0.80859 2.4161 1.6108 1.3772 1.7063-2.0247 6.405-2.9922 8.748 0.93964z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(.98928 0 0 1 1.1742 -1.9626)",
  strokeMiterlimit: 10,
  strokeWidth: 1.0054
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m5.4587 11.759c0-1.1931 0.96039-2.1603 2.1456-2.1603h10.013c1.1852 0 2.1456 0.96719 2.1456 2.1603v8.6412c0 1.1931-0.96039 2.1603-2.1456 2.1603h-10.013c-1.1852 0-2.1456-0.96719-2.1456-2.1603z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.0054
}), React.createElement("g", {
  transform: "matrix(.59302 0 0 .58896 3.8767 9.4432)",
  fill: "#adb9ca",
  strokeWidth: 1.7012
}, React.createElement("path", {
  className: "icon-primary",
  d: "m6.3054 1.0391h17.022c2.0097 0 3.6377 1.6535 3.6377 3.6935v4.2347h-24.297v-4.2347c0-2.0399 1.6279-3.6935 3.6377-3.6935z",
  fillRule: "evenodd"
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 7.5272,
  y: 11.725,
  width: 3.1239,
  height: 2.2914
}), React.createElement("rect", {
  className: "icon-secondary",
  x: 7.704,
  y: 16.887,
  width: 2.8882,
  height: 1.9238
})), React.createElement("g", {
  stroke: "#002060"
}, React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.59302 0 0 .58896 5.1638 9.2395)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.7012
}, React.createElement("path", {
  d: "m4.5971 3.9951c0-0.28118 0.21258-0.50926 0.47123-0.50926h15.001c0.25864 0 0.47123 0.22808 0.47123 0.50926v2.0378c0 0.28118-0.21258 0.50926-0.47123 0.50926h-15.001c-0.25864 0-0.47123-0.22808-0.47123-0.50926z",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m4.1084 0.6104h16.898c1.9951 0 3.6112 1.6535 3.6112 3.6935v4.2347h-24.121v-4.2347c0-2.0399 1.6161-3.6935 3.6112-3.6935z",
  fill: "none"
})), React.createElement("path", {
  d: "m12.483 16.96h4.6571",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeWidth: 1.0054
}), React.createElement("path", {
  d: "m12.483 19.757h4.6571",
  fill: "#e2f0d9",
  fillRule: "evenodd",
  strokeWidth: 1.0054
}), React.createElement("rect", {
  x: 8.1993,
  y: 16.323,
  width: 1.9385,
  height: 1.2372,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.60324
}), React.createElement("rect", {
  x: 8.1792,
  y: 19.129,
  width: 1.9789,
  height: 1.133,
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.60324
})));

var SvgSidepanelDataTriggers = function SvgSidepanelDataTriggers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSidepanelDataTriggers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidepanel-data-triggers.81c0103e.svg";
export { ForwardRef as ReactComponent };